import { render, staticRenderFns } from "./ExamHeadTeacherMarkPage.vue?vue&type=template&id=2014fbf2&scoped=true&"
import script from "./ExamHeadTeacherMarkPage.vue?vue&type=script&lang=js&"
export * from "./ExamHeadTeacherMarkPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamHeadTeacherMarkPage.vue?vue&type=style&index=0&id=2014fbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014fbf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
